import { ThemeProps } from "./types"
import getBaseUrl from "./utils/getBaseUrl"

export const baseURL: string | undefined = getBaseUrl()

const defaultHeaders = {
  'Content-Type': 'application/json;charset=UTF-8'
}

const handleResponse = (response: Response) => {
  if (!response.ok) throw response.json();
  return response.json()
}

const handleEmptyResponse = (response: Response) => {
  // eslint-disable-next-line no-throw-literal
  if(!(response.status === 204)) throw '';
  return '';
}

export const getClientToken: (_: string, { config }: { config: any }) => Promise<any> = (_, { config }) => fetch(config.url, { ...config }).then(res => res.text())

export const getConfig: (_: string, product: string) => any = (_, product) => fetch(`https://s3.eu-central-1.amazonaws.com/account-develop.dvmkids.ninja/config/${product}/config.json`, { method: 'GET' }).then(res => handleResponse(res));

export const getDefaultCopy: (_: string, product: 'azoomee' | 'davincikids') => any = (_, product) => fetch(`https://s3.eu-central-1.amazonaws.com/account-develop.dvmkids.ninja/config/${product}/translations/en.json`, { method: 'GET' }).then(res => handleResponse(res))

export const getDefaultTheme: (_: string, product: 'azoomee' | 'davincikids') => Promise<ThemeProps> = (_, product) => fetch(`https://s3.eu-central-1.amazonaws.com/account-develop.dvmkids.ninja/config/${product}/theme.json`, { method: 'GET' }).then(res => handleResponse(res))

export const getDiscountedPlan: (_: string, voucherCode: string) => Promise<any> = (_, voucherCode) => fetch(`${baseURL}/api/billing/user/anon/voucher?voucherCode=${voucherCode}`, { method: 'GET' }).then(res => handleResponse(res));

export const getPasswordReset: (_: string, emailAddress: string) => Promise<any> = (_, emailAddress) => fetch(`${baseURL
  }/api/auth/requestPasswordReset?emailAddress=${encodeURIComponent(
    emailAddress
  )}`, { method: 'GET' }).then(res => {
    if (!res.ok) {
      throw res
    }
    return res
  });

export const getPlans: () => Promise<any> = () => fetch(`${baseURL}/api/billing/user/anon/plans`, { method: 'GET' }).then(res => handleResponse(res))

export const getTranslations: (_: string, { locale, product }: { locale: string, product: string }) => any = (_, { locale, product }) => {
  // return require(`./translations/${locale}.json`);
  return fetch(`https://s3.eu-central-1.amazonaws.com/account-ci.dvmkids.ninja/config/${product}/translations/${locale}.json`, { method: 'GET' }).then(res => handleResponse(res))
}

export const getVFAvailability: (_: string) => Promise<any> = (_) => fetch(`${baseURL}/api/billing/vodafone/locale/valid`, { headers: defaultHeaders }).then(res => handleResponse(res))

export const patchVoucherToProfile: (config: any) => Promise<any> = (config) => fetch(config.url, { ...config, body: JSON.stringify({ ...config.data }) }).then(res => handleResponse(res))

export const postBtPaymentData: ({ config }: { config: any }) => Promise<any> = ({ config }) => fetch(config.url, { ...config, body: JSON.stringify({ ...config.data }) }).then(res => res.json())

export const patchPaymentCardData: ({ config }: { config: any }) => Promise<any> = ({ config }) => fetch(config.url, { ...config, body: JSON.stringify({ ...config.data }) }).then(res => handleEmptyResponse(res))

export const postUserSignin: (data: { password: string, userName: string }) => Promise<any> = (data) => fetch(`${baseURL}/api/auth/login`, {
  body: JSON.stringify(data), headers: defaultHeaders, method: 'POST',
}).then(async (response: Response) => {
  const data: any = await response.json();
  /**
  * This `login` is an 'old' endpoint. When an invalid password is POSTed, it returns
  * a 200 with the error in the body of the response. We will throw it here and
  * handle the error in the useMutation hook theat sends this error
  */
  if (data.error) {
    throw data
  }

  return { data, resHeaders: response.headers };
})

export const postUserSignup: (data: any) => Promise<any> = (data) => fetch(`${baseURL}/api/user/v2/signup`, {
  body: JSON.stringify(data),
  headers: defaultHeaders,
  method: 'POST'
}).then(res => handleResponse(res))

export const postVfPayment: ({ config }: { config: any }) => Promise<any> = ({ config }) => fetch(config.url, {
  ...config, body: JSON.stringify({ ...config.data })
}).then(res => handleResponse(res))